import '../styles/AddStudentDialog.css'
import { createTheme, ThemeProvider } from "@material-ui/core";
import moment from 'moment';
import { ReactNode, useState } from 'react';
import { useCookies } from 'react-cookie';

import StudentNameTable from './StudentNameTable';
import closeIcon from '../images/close-icon.svg'

import { GridSelectionModel } from '@material-ui/data-grid';
import axios from 'axios';
import { IndividualGoalType } from './IndividualGoal';

import DatePickerInput from './DatePickerInput';
import LinearProgressBar from './LinearProgressBar';
import SnackbarAlert from './SnackbarAlert';

interface AddStudentDialogProps {
    goalIdTarget: number;
    goalList: IndividualGoalType[];
    courseId: number;
    semesterId: number;
    handleClickClose: any;
    handleBackDropClick: any;
    isScholarship: boolean;
}

const AddStudentDialog = ({ goalIdTarget, goalList, courseId, semesterId, handleClickClose, handleBackDropClick, isScholarship }: AddStudentDialogProps) => {

    const [selectedDate, setSelectedDate] = useState<null | moment.Moment>(null);
    const [selectionModel, setSelectionModel] = useState<GridSelectionModel>([]);
    const [cookies] = useCookies(['user'])
    const [loading, setLoading] = useState(false)

    const studentNameTableTheme = createTheme({
        palette: {
            primary: {
                main: '#005BAE',
            },
        },
        typography: {
            fontFamily: 'Sarabun',
            fontSize: 14,
        },
    });

    const goalTarget = goalList?.find(goal => goal.id === goalIdTarget)
    const goalNameTarget = goalTarget?.goal || goalTarget?.name

    const fetchURL = isScholarship ? `/ScholarshipProgresses` : `/IndividualProgresses`

    const [snackbarMessage, setSnackbarMessage] = useState<null | {
        message: ReactNode,
        severity?: 'success' | 'info' | 'warning' | 'error',
        autoHideDuration?: number | null
    }>(null)

    const handleClickAdd = () => {
        setLoading(true)
        setSnackbarMessage(null)
        axios.post(fetchURL, {
            goalId: goalIdTarget,
            deadline: selectedDate,
            studentList: selectionModel,
            staffId: cookies.user.staffId
        }, {
            headers: {
                'Authorization': `Bearer ${cookies?.user?.token}`
            },
            withCredentials: true
        }).then(res => {
            
            setSnackbarMessage({
                message: `Successfully added ${selectionModel.length} student(s) to ${goalNameTarget}`,
                severity: 'success',
                autoHideDuration: 1500
            })
            setTimeout(() => {
                handleClickClose()
                setLoading(false)
            }, 2000)
        }
        ).catch(err => {
            setLoading(false)
            setSnackbarMessage({
                message: (err.response.status === 409 && err.response.data?.duplicates?.length > 0) ? <><strong>Duplicate student(s) found:</strong><br/> {err.response.data.duplicates.map((dup:string) => <>{dup}<br/></>)}</> : err.response.data.message || 'Something went wrong',
                severity: 'error',
                autoHideDuration: 3000
            })
        })
    }

    return (
        <div className="ProgressDialog" onClick={handleBackDropClick}>

            <div className="ProgressDialog-dialog">
                <button className="ProgressDialog-close-button" onClick={handleClickClose}>
                    <img src={closeIcon} width={24} height={24} alt="close-icon" />
                </button>
                {
                    (loading) &&
                    <div className="ProgressDialog-linear-progress">
                        <LinearProgressBar />
                    </div>
                }
                <div className="AddStudentDialog-header-container">
                    <h4 className='AddStudentDialog-title'>+ Add New Progress to</h4>
                    <h4 className='AddStudentDialog-goal-name'>{goalNameTarget}</h4>
                </div>

                <div className='AddStudentDialog-deadline'>
                    <DatePickerInput
                        label='Due Date'
                        emptyLabel='Select Date'
                        selectedDate={selectedDate}
                        setSelectedDate={setSelectedDate}
                        disabled={loading}
                        inputVariant="outlined"
                        required
                        style={
                            {
                                padding: '15px 14px',
                            }
                        }
                    />
                </div>

                <ThemeProvider theme={studentNameTableTheme}>
                    <StudentNameTable
                        courseId={courseId}
                        semesterId={semesterId}
                        selectionModel={selectionModel}
                        setSelectionModel={setSelectionModel}
                        setSnackbarMessage={setSnackbarMessage}
                    />
                </ThemeProvider>
                <div className="ProgressDialog-bottom-container" >
                    <div className="ProgressDialog-actions" style={{ marginLeft: 'auto' }}>
                        <button className="ProgressDialog-button" onClick={handleClickClose}>Cancel</button>
                        <button className="ProgressDialog-button" onClick={handleClickAdd} disabled={selectionModel.length == 0 || selectedDate == null || loading}>Add</button>
                    </div>
                </div>
            </div>
            {
                (snackbarMessage) &&
                <SnackbarAlert severity={snackbarMessage.severity} message={snackbarMessage.message} />
            }
        </div>
    )
}

export default AddStudentDialog